import React from 'react';
import Icon from '../../../components/AppIcon';

const WelcomeCard = ({ userName, userType, impactStats }) => {
  const getGreeting = () => {
    const hour = new Date()?.getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 18) return 'Good afternoon';
    return 'Good evening';
  };

  return (
    <div className="bg-gradient-to-br from-primary to-secondary rounded-xl p-6 lg:p-8 text-white shadow-lg">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
        <div className="flex-1">
          <h1 className="text-2xl lg:text-3xl font-bold mb-2">
            {getGreeting()}, {userName}!
          </h1>
          <p className="text-white/90 text-base lg:text-lg mb-4">
            {userType === 'volunteer' ?'Ready to make a difference today?' :'Your community impact dashboard awaits'}
          </p>
          <div className="flex flex-wrap gap-4 lg:gap-6">
            <div className="flex items-center gap-2">
              <Icon name="Clock" size={20} color="white" />
              <div>
                <p className="text-sm text-white/80">Total Hours</p>
                <p className="text-xl font-bold">{impactStats?.totalHours}</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Award" size={20} color="white" />
              <div>
                <p className="text-sm text-white/80">Completed</p>
                <p className="text-xl font-bold">{impactStats?.completed}</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Heart" size={20} color="white" />
              <div>
                <p className="text-sm text-white/80">Impact Score</p>
                <p className="text-xl font-bold">{impactStats?.impactScore}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-shrink-0">
          <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4 text-center">
            <Icon name="TrendingUp" size={32} color="white" className="mx-auto mb-2" />
            <p className="text-sm text-white/90">This Month</p>
            <p className="text-2xl font-bold">{impactStats?.monthlyHours}h</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeCard;